/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import { UpdateUserSubtenantsModal } from '@/pages/Users/UpdateUsersSubtenantsModal';

export function UpdateUserSubtenantsPage() {
  return <UpdateUserSubtenantsModal />;
}
